<app-header></app-header>

<!--====== PAGE TITLE PART START ======-->
<div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i" 
         [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <span class="assurance">{{slide.type}}</span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" [src]="slide.imgIcon" alt="">
                            </div>
                            <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title" *ngIf="title!=''">{{title}}</span>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="getDevisAutre()">Obtenir un devis</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="case-studies-area">
  <div class="container">
    
    <!-- Barre de progression -->
    <div class="row" *ngIf="currentStep > 0 && currentStep < 5">
      <div class="devis">
        <div class="title">Mon devis</div>
        <img src="assets/images/stopwatch.svg" alt="">
      </div>
      <div class="temps">
        <span class="barre-temps"></span>
        <span class="message-temps">En quelques minutes</span>
      </div>
    </div>

    <!-- <div class="progress" *ngIf="currentStep > 0 && currentStep < 4">
      <div class="progress-bar progress-bar-striped progress-bar-animated" 
           [style.width.%]="getProgressPercentage()"></div>
      <span class="text-changement">{{getProgressText()}}</span>
    </div> -->

    <div class="latest-services-area">
      <div class="container">
        <div class="formulaire" *ngIf="currentStep >= 0">
          <form [formGroup]="simulationSanteForm" class="form-wizard-container">
            
            <!-- Page d'accueil -->
            <div class="welcome-step" *ngIf="currentStep === 0">
              <div class="welcome-content">
                <h1>Bonjour ! Je suis Marilyne</h1>
                <h2>Je suis là pour vous aider</h2>
                <p class="welcome-description">
                  Obtenez votre devis d'assurance santé en quelques minutes seulement.
                  Je vais vous guider étape par étape pour trouver la meilleure protection santé pour vous ou votre entreprise.
                </p>
                <button class="cta-button" (click)="nextStep()">
                  C'est parti !!
                </button>
              </div>
            </div>

            <!-- Étape 1: Choix du type (Particulier/Entreprise) -->
            <div class="step-container" *ngIf="currentStep === 1">
              <div class="step-header">
                <h2>Êtes-vous ?</h2>
                <p class="step-subtitle">Choisissez votre profil pour une offre adaptée</p>
                <div class="step-progress">Étape 1 sur 3</div>
              </div>

              <div class="options-grid">
                <div class="option-card" 
                     [class.selected]="selectedOption === 'Particulier'"
                     (click)="selectOption('Particulier')">
                  <div class="option-icon">
                    <img src="assets/images/Icon-sante-green.svg" alt="Particulier">
                  </div>
                  <h3>Particulier</h3>
                  <p>Protection santé pour vous et votre famille</p>
                </div>

                <div class="option-card" 
                     [class.selected]="selectedOption === 'Entreprise'"
                     (click)="selectOption('Entreprise')">
                  <div class="option-icon">
                    <img src="assets/images/Icon-sante-green.svg" alt="Entreprise">
                  </div>
                  <h3>Entreprise</h3>
                  <p>Couverture santé collective pour vos employés</p>
                </div>
              </div>

              <div class="step-navigation" *ngIf="selectedOption">
                <button class="btn-back" (click)="currentStep = 0">Retour</button>
                <button class="btn-continue" (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 2: Informations (Particulier ou Entreprise) -->
            <div class="step-container" *ngIf="currentStep === 2">
              <div class="step-header">
                <h2 *ngIf="selectedOption === 'Particulier'">Informations de l'assuré</h2>
                <h2 *ngIf="selectedOption === 'Entreprise'">Informations de l'entreprise</h2>
                <p class="step-subtitle">Vos informations pour établir le devis</p>
                <div class="step-progress">Étape 2 sur 3</div>
              </div>

              <!-- Formulaire Particulier -->
              <div class="form-grid formulaire" *ngIf="selectedOption === 'Particulier'">
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="text" formControlName="nom" placeholder="Nom" noAutocomplete>
                    <img class="img-form" popover="Nom" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="text" formControlName="prenom" placeholder="Prénom" noAutocomplete>
                    <img class="img-form" popover="Prénom" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                </div>
              </div>

              <div class="form-grid formulaire" *ngIf="selectedOption === 'Particulier'">
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="text" 
                         formControlName="dateNaiss"
                         bsDatepicker
                         [maxDate]="newDate"
                         [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', locale: 'fr'}"
                         placeholder="Date de naissance">
                  <span class="input-icon">
                    <img src="assets/images/icon-date.svg" alt="">
                  </span>
                </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="text" formControlName="adresse" placeholder="Lieu de résidence">
                    <img class="img-form" popover="Adresse" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/icon-adresse.svg" alt="">
                    <i class="barre"></i>
                  </div>
                </div>
              </div>

              <!-- Formulaire Entreprise -->
              <div class="form-grid formulaire" *ngIf="selectedOption === 'Entreprise'">
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="text" formControlName="nomEntreprise" placeholder="Dénomination" noAutocomplete>
                    <img class="img-form" popover="Dénomination" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/icon-personne-morale.svg" alt="">
                    <i class="barre"></i>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="text" formControlName="name" placeholder="Personne contact" noAutocomplete>
                    <img class="img-form" popover="Personne contact" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                </div>
              </div>

              <div class="form-grid formulaire" *ngIf="selectedOption === 'Entreprise'">
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="text" formControlName="service" placeholder="Secteur d'activités" noAutocomplete>
                  <img class="img-form" popover="Secteur d'activités" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/icon-fonction.svg" alt="">
                  <i class="barre"></i>
                </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="text" formControlName="adresse" placeholder="Adresse" noAutocomplete>
                  <img class="img-form" popover="Adresse" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/icon-adresse.svg" alt="">
                  <i class="barre"></i>
                </div>
              </div>
              </div>
              <!-- Champs communs -->
              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="email" formControlName="email" placeholder="Courriel *" noAutocomplete>
                    <img class="img-email" popover="Email" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/icon-email.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  <div *ngIf="simulationSanteForm.get('email').errors">
                      <div
                        *ngIf="simulationSanteForm.get('email').errors.required && (simulationSanteForm.get('email').dirty || simulationSanteForm.get('email').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                      <div *ngIf="simulationSanteForm.get('email').errors.pattern">
                        <div class="text-red">
                          Email est invalide
                        </div>
                      </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box sinistre mt-30">
                    <input type="tel" 
                           formControlName="telephone"
                           ng2TelInput 
                           [ng2TelInputOptions]="{initialCountry: currentFiliale?.code}"
                           placeholder="Téléphone *"
                           (focus)="isFocus=true" 
                           (blur)="isFocus=false; hasError($event, 'telephone', 'simulationSanteForm');autoSave()"
                           (ng2TelOutput)="getNumber($event, 'telephone', 'simulationSanteForm')"
                           (intlTelInputObject)="telInputObject($event)" 
                           (countryChange)="onCountryChange($event)"
                           noAutocomplete>
                  </div>
                  <div *ngIf="simulationSanteForm.get('telephone').errors">
                      <div
                        *ngIf="simulationSanteForm.get('telephone').errors.required && (simulationSanteForm.get('telephone').dirty || simulationSanteForm.get('telephone').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                </div>
              </div>

              <!-- Informations population (Particulier) -->
              <div class="formulaire" *ngIf="selectedOption === 'Particulier'">
                <div class="form-grid">
                  <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="number" (blur)="checkNumberValue()" formControlName="conjoint" placeholder="Conjoint(es)" min="0">
                    <img class="img-form" popover="Conjoint(es)" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  </div>
                   <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="number" (blur)="checkNumberValue()" formControlName="assurePincipale" placeholder="Assuré(s) principale(aux)" min="0">
                    <img class="img-form" popover="Assuré(s) principale(aux)" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  </div>
                </div>
                <div class="form-grid">
                  <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="number" (blur)="checkNumberValue()" formControlName="enfant" placeholder="Enfant mineur(s)" min="0">
                    <img class="img-form" popover="Enfant mineur(s)" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="number" (blur)="checkNumberValue()" formControlName="enfantMajeur" placeholder="Enfant majeur(s)" min="0">
                    <img class="img-form" popover="Enfant majeur(s)" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="number" formControlName="effectif" placeholder="Population totale" readonly>
                  <img class="img-form" popover="Population totale" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/nom.svg" alt="">
                  <i class="barre"></i>
                </div>
                </div>
              </div>

              <!-- Informations population (Entreprise) -->
              <div class="formulaire" *ngIf="selectedOption === 'Entreprise'">
                <div class="form-grid">
                  <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="number" (blur)="checkNumberValue()" formControlName="conjoint" placeholder="Conjoint(es)" min="0">
                    <img class="img-form" popover="Conjoint(es)" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="number" (blur)="checkNumberValue()" formControlName="assurePincipale" placeholder="Assuré(s) principale(aux)" min="0">
                    <img class="img-form" popover="Assuré(s) principale(aux)" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  </div>
                </div>
                <div class="form-grid">
                  <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="number" (blur)="checkNumberValue()" formControlName="enfant" placeholder="Enfant mineur(s)" min="0">
                    <img class="img-form" popover="Enfant mineur(s)" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="number" (blur)="checkNumberValue()" formControlName="enfantMajeur" placeholder="Enfant majeur(s)" min="0">
                    <img class="img-form" popover="Enfant majeur(s)" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="number" formControlName="effectif" placeholder="Population totale" readonly>
                  <img class="img-form" popover="Population totale" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/nom.svg" alt="">
                  <i class="barre"></i>
                </div>
                </div>
              </div>

              <!-- Taux de couverture -->
              <div class="formulaire">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Taux de couverture</div>
                    <div class="col-md-3 col-sm-6 col-xs-12" *ngFor="let taux of listTauxCouverture">
                      <input type="radio" [id]="taux.value" [value]="taux.value" formControlName="taux" />
                      <label [for]="taux.value">{{taux.name}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Territorialité -->
              <div class="formulaire">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Territorialité</div>
                    <div class="col-md-4 col-sm-6 col-xs-12" *ngFor="let territoire of listTerritorialite">
                      <input type="radio" [id]="territoire.value" [value]="territoire.value" formControlName="territorialite" />
                      <label [for]="territoire.value">{{territoire.name}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 3: Choix des garanties -->
            <div class="step-container" *ngIf="currentStep === 3">
              <div class="step-header">
                <h2>Récapitulatif des prestations</h2>
                <p class="step-subtitle">Choisissez vos garanties santé</p>
                <div class="step-progress">Étape 3 sur 3</div>
              </div>

              <!-- Choix des garanties -->
              <!-- <div class="formulaire">
                <div class="input-checkbox">
                  <div class="row">
                    <div class="isLabel">Choix des garanties</div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let garantie of listGaranties">
                      <input type="checkbox" [id]="garantie.value" [value]="garantie.value" formControlName="type" />
                      <label [for]="garantie.value" class="label-garantie">{{garantie.name}}</label>
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="formulaire">
  <div class="input-checkbox">
    <div class="row">
      <div class="isLabel">Choix des garanties</div>
      <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let garantie of listGaranties">
        <input type="checkbox" 
               [id]="garantie.value" 
               [value]="garantie.value" 
               [checked]="isGarantieSelected(garantie.value)"
               (change)="toggleGarantie(garantie.value)" />
        <label [for]="garantie.value" class="label-garantie">{{garantie.name}}</label>
      </div>
    </div>
  </div>
</div>

              <!-- Évacuation sanitaire -->
              <div class="formulaire">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Évacuation sanitaire</div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let evacuation of listEvacuation">
                      <input type="radio" [id]="evacuation.value" [value]="evacuation.value" formControlName="evacuation" />
                      <label [for]="evacuation.value">{{evacuation.name}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Voir le récapitulatif</button>
              </div>
            </div>

            <!-- Récapitulatif -->
            <div class="step-container_2" *ngIf="currentStep === 4">
              <div class="step-header">
                <h2>Récapitulatif de votre demande d'assurance santé</h2>
                <p class="step-subtitle">Vérifiez vos informations avant de finaliser</p>
              </div>

              <div class="recap-form-container">
                <div class="mesImage">
                  <div class="imgLogo">
                    <img src="assets/images/logo.png" alt="Logo Inclusive Guarantee">
                  </div>
                </div>
                
                <div class="info-devis">
                  <div class="proposition">
                    <div class="pro-title">Demande d'assurance santé</div>
                    <div class="sub-title">{{numeroSous}}</div>
                  </div>
                  
                  <div class="row">
                    <!-- Informations souscripteur -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span *ngIf="selectedOption === 'Particulier'">Informations de l'assuré</span>
                        <span *ngIf="selectedOption === 'Entreprise'">Informations de l'entreprise</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Numéro</div>
                            <div class="col-7 value">{{numeroSous}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="selectedOption === 'Particulier'">
                            <div class="col-5 name">Nom & Prénom</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('nom')?.value}} {{simulationSanteForm?.get('prenom')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="selectedOption === 'Entreprise'">
                            <div class="col-5 name">Entreprise</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('nomEntreprise')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="selectedOption === 'Entreprise'">
                            <div class="col-5 name">Contact</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('name')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="selectedOption === 'Particulier'">
                            <div class="col-5 name">Date de naissance</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('dateNaiss')?.value | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Email</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('email')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Téléphone</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('telephone')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Adresse</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('adresse')?.value}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Informations couverture -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations couverture</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Référence</div>
                            <div class="col-7 value">{{refPro}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Type</div>
                            <div class="col-7 value">{{selectedOption}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Taux couverture</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('taux')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Territorialité</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('territorialite')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Population totale</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('effectif')?.value || 0}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Évacuation sanitaire</div>
                            <div class="col-7 value">{{simulationSanteForm?.get('evacuation')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Date de demande</div>
                            <div class="col-7 value">{{newDate | date:'dd/MM/yyyy'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Garanties sélectionnées -->
                  <div class="row">
                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
                      <div class="title-div">
                        <span>Garanties sélectionnées</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12">
                            <div class="value c-value">{{simulationSanteForm?.get('type')?.value || 'Aucune garantie sélectionnée'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="description-ass">
                    Cette demande d'assurance santé sera traitée par nos équipes dans les plus brefs délais. 
                    Vous recevrez une confirmation par email avec les détails de votre couverture santé.
                  </div>
                  
                  <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Demande d'assurance santé
                    </div>
                    <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Date émission : {{newDate | date:'dd/MM/yyyy'}} - E-MAIL : contact&#64;inclusiveguarantee.fr
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">
                  <!-- <i class="fa fa-arrow-left"></i> -->
                  Retour
                </button>
                <button type="button" class="btn-continue final-btn" [disabled]="sendingRequest" (click)="saveData()">
                  <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequest"></i>
                  <span *ngIf="!sendingRequest">Finaliser la souscription</span>
                  <span *ngIf="sendingRequest">Traitement en cours...</span>
                </button>
              </div>
            </div>

            <!-- Étape succès -->
            <div class="step-container" *ngIf="currentStep === 5">
              <div class="success-auto">
                <div class="icon-succes">
                <img width="10%" src="/assets/images/verifier.png" alt="" srcset=""> 
                </div>
                <!-- <div class="message-success">
                  Votre demande d'assurance santé a été enregistrée avec succès !
                  <span>Numéro de référence : {{numeroSous}}</span>
                  <span>Nos équipes vous contacteront dans les plus brefs délais.</span>
                </div> -->
                <div class="message-success">
                  Votre demande a été soumise avec succès. Vous recevrez un devis sous 48h. Merci pour la confiance.
                  <span>L'équipe d'Inclusive Guarantee</span>
                </div>
                <button class="btn-success" (click)="resetForm()">
                  <span>Nouvelle demande</span>
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>